<template>
  <div class="aboutpage1">
    <div class="page1-text" v-html="content"></div>
  </div>
</template>

<script>
import { getSocietyIntroduction } from "@/api/api.js";

export default {
  data() {
    return {
      content: "暂无数据"
    };
  },
  components: {},
  mounted() {
    this.getSocietyIntroduction();
  },
  methods: {
    getSocietyIntroduction() {
      getSocietyIntroduction().then(res => {
        if (res.code === 0) {
          // this.ImgData = res.data;
          this.content = res.data.content ? res.data.content : "暂无数据";
        } else {
          this.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    }
  }
};
</script>

<style lang="less">
.aboutpage1 {
  // .page1-box {
  //   width: 1000px;
  //   margin: 0 auto;
  //   padding: 50px 60px;
  //   background: rgba(245, 248, 251, 1);
  //   font-size: 16px;
  //   font-weight: 400;
  //   text-align: center;
  //   color: rgba(52, 52, 52, 1);
  //   line-height: 28px;
  // }
  // .page1-img {
  //   margin: 40px auto;
  //   text-align: center;
  // }
  .page1-text {
    margin: 0 auto 20px;
    width: 1000px;
    font-size: 16px;
    font-weight: 400;
    color: rgba(52, 52, 52, 1);
    line-height: 28px;
    text-indent: 2em;
  }
}
</style>
